import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import React from "react";
import { PICGroupWithCategories } from "../../../../common/service/server/dto/datamap/DataMapDto";
import { GroupIcon } from "../../../pages/get-compliant/data-map/GroupIcon";

type PicGroupListProps = {
  picGroups: PICGroupWithCategories[];
};
export const PicGroupList: React.FC<PicGroupListProps> = ({ picGroups }) => (
  <List className="p-0">
    {picGroups.map((group) => (
      <ListItem disableGutters key={group.id}>
        <ListItemIcon>
          <GroupIcon groupName={group.name} color="inherit" />
        </ListItemIcon>
        <ListItemText
          primary={group.name}
          secondary={group.categories.map((g) => g.name).join(", ")}
        />
      </ListItem>
    ))}
  </List>
);
